// src/pages/Login.js

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../services/api';
import { jwtDecode } from 'jwt-decode';
import Card from '../components/Card';
import Button from '../components/Button';

function Login() {
  const [username, setUsername] = useState('');
  //const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // --- NUEVA LÓGICA: Verificar si ya hay sesión ---
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      try {
        // Si el token existe y es válido, redirigimos automáticamente
        const userData = jwtDecode(token);
        if (userData.rol === 'PADRE') {
          navigate('/dashboard-padre');
        } else if (userData.rol === 'NINO') {
          navigate('/dashboard-nino');
        }
      } catch (err) {
        // Si el token es basura, lo borramos y dejamos que se muestre el login
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
      }
    }
  }, [navigate]);
  // -----------------------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await apiClient.post('/token/', {
        username: username, 
        password: password,
      });

      localStorage.setItem('accessToken', response.data.access);
      localStorage.setItem('refreshToken', response.data.refresh);
      
      const userData = jwtDecode(response.data.access);

      if (userData.rol === 'PADRE') {
        navigate('/dashboard-padre');
      } else if (userData.rol === 'NINO') {
        navigate('/dashboard-nino');
      } else {
        setError('Rol de usuario no reconocido.');
      }

    } catch (err) {
      console.error("Error login:", err);
      setError('Correo electrónico o contraseña incorrectos.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-fondo p-4">
      <Card className="w-full max-w-sm p-8">
        <h1 className="text-3xl font-bold text-center text-principal mb-2">¡Bienvenido!</h1>
        <p className="text-center text-gray-500 mb-6">Entra a tu mundo mágico ✨</p>
        
        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6" role="alert">
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Nombre de usuario</label>
            <input 
              type="text"
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
              placeholder="Tu nombre de usuario"
              required 
            />
          </div>

          <div className="mb-8">
            <label className="block text-gray-700 font-bold mb-2">Contraseña</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
              placeholder="••••••••"
              required 
            />
          </div>
          


          <Button type="submit" variant="primary" className="w-full text-lg py-3">
            Entrar
          </Button>

          <div className="flex justify-end mb-6">
            <Link to="/forgot-password" className="text-sm text-principal hover:underline">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </form>

        <div className="mt-6 text-center border-t pt-4">
          <p className="text-sm text-gray-600">
            ¿No tienes cuenta?{' '}
            <Link to="/registro" className="font-bold text-principal hover:underline">
              Regístrate aquí
            </Link>
          </p>
        </div>
      </Card>
    </div>
  );
}

export default Login;